import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as RootRoute, requireAdminRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/settings",
  beforeLoad: requireAdminRoute,
  component: lazyRouteComponent(() => import("./settings"), "SettingsPage"),
});
